import styled, { css } from "styled-components";

import {
  BRAND_LIGHT,
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  TEXT_PRIMARY,
  WHITE
} from "../../../../colors";
import { Body } from "../../../../typography";
import { chevron } from "../../../assets";
import { textFieldStyles, withInputSizeStyles } from "../../../styled";

const inactiveOptionCss = css`
  background: transparent;
  color: ${TEXT_PRIMARY};
`;

const activeOptionCss = css`
  background: ${BRAND_LIGHT};
  color: ${WHITE};
`;

const embedOptionCss = ({ isActive }) =>
  isActive ? activeOptionCss : inactiveOptionCss;

export const ComboboxWrapper = styled.div.attrs({
  "aria-haspopup": "listbox",
  role: "combobox"
})`
  position: relative;
`;

export const Input = styled.input.attrs(({ isValid, type = "text" }) => ({
  "aria-invalid": !isValid,
  autoComplete: "off",
  type
}))`
  ${textFieldStyles};
  ${withInputSizeStyles};

  background-image: url(${chevron});
  background-position: calc(100% - 12px) center;
  background-repeat: no-repeat;
  box-sizing: border-box;
  padding: 0 32px 0 16px;

  &:disabled {
    background-image: none;
  }
`;

export const Datalist = styled.ul.attrs({
  role: "listbox"
})`
  background: ${GRAY_LIGHTEST};
  border: 1px solid ${GRAY_LIGHT};
  border-radius: 12px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.16);
  box-sizing: border-box;
  display: ${({ isExpanded }) => (isExpanded ? "block" : "none")};
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
`;

export const Option = styled(Body).attrs(({ isActive }) => ({
  "aria-selected": isActive,
  as: "li",
  role: "option"
}))`
  ${embedOptionCss};

  cursor: pointer;
  font-weight: normal;
  list-style: none;
  padding: 4px 16px;

  &:hover {
    ${activeOptionCss}
  }
`;
